<template>
  <div class="warning-status text-center">
    <div class="section py-6">
      <div>
        <h2>
          {{ $t("waterFloodArea") }}
        </h2>
      </div>
      <div class="pa-2" v-if="statusList.first">
        <warning-status-layout :data="statusList.first"></warning-status-layout>
        <div v-if="statusList.first && statusList.first.status.length === 0">
          {{ $t("waterFloodAreaAnnounce") }}
        </div>
      </div>
    </div>
    <div class="section py-6">
      <h2>
        {{ $t("whetherAlert") }}
      </h2>
      <h4>
        （
        <a href="https://www.jma.go.jp/jp/warn/" target="_blank">
          {{ $t("meteorologicalAgency") }}
        </a>
        ）
      </h4>

      <div class="pa-2" v-if="statusList.second">
        <warning-status-layout
          :data="statusList.second"
        ></warning-status-layout>
        <div v-if="statusList.second && statusList.second.status.length === 0">
          {{ $t("alertAnnounce") }}
        </div>
      </div>
    </div>
  </div>
</template>
<i18n>
{
  "ja": {
    "waterFloodArea": "内水予測地域",
    "waterFloodAreaAnnounce": "内水予測エリアはありません",
    "whetherAlert": "現在発表中の警報",
    "meteorologicalAgency": "気象庁",
    "alertAnnounce": "警報発表中の地域はありません"
  },
  "en": {
    "waterFloodArea": "Stormwater flooding predicted area",
    "waterFloodAreaAnnounce": "There is no flooding predicted area.",
    "whetherAlert": "Currently announced warning",
    "meteorologicalAgency": "Japan Meteorological Agency",
    "alertAnnounce": "Currently there is no aera with a warning."
  }
}
</i18n>
<script>
import { RISK } from "@/enums/Risk";
import WarningStatusLayout from "@/components/risk-map-view/WarningStatusLayout";
import axios from "axios";
import moment from "moment";

export default {
  name: "WarningStatus",
  components: { WarningStatusLayout },
  data() {
    return {
      token: null,
      alertStatus: [],
      guerrillaRainPrefectures: [
        "福島県",
        "茨城県",
        "栃木県",
        "群馬県",
        "埼玉県",
        "千葉県",
        "東京都",
        "神奈川県",
        "新潟県",
        "富山県",
        "石川県",
        "福井県",
        "山梨県",
        "長野県",
        "岐阜県",
        "静岡県",
        "愛知県",
        "三重県",
      ],
      prefectureMap: {
        "01": "北海道",
        "02": "青森県",
        "03": "岩手県",
        "04": "宮城県",
        "05": "秋田県",
        "06": "山形県",
        "07": "福島県",
        "08": "茨城県",
        "09": "栃木県",
        10: "群馬県",
        11: "埼玉県",
        12: "千葉県",
        13: "東京都",
        14: "神奈川県",
        15: "新潟県",
        16: "富山県",
        17: "石川県",
        18: "福井県",
        19: "山梨県",
        20: "長野県",
        21: "岐阜県",
        22: "静岡県",
        23: "愛知県",
        24: "三重県",
        25: "滋賀県",
        26: "京都府",
        27: "大阪府",
        28: "兵庫県",
        29: "奈良県",
        30: "和歌山県",
        31: "鳥取県",
        32: "島根県",
        33: "岡山県",
        34: "広島県",
        35: "山口県",
        36: "徳島県",
        37: "香川県",
        38: "愛媛県",
        39: "高知県",
        40: "福岡県",
        41: "佐賀県",
        42: "長崎県",
        43: "熊本県",
        44: "大分県",
        45: "宮崎県",
        46: "鹿児島県",
        47: "沖縄県",
      },
      floodLevels: [
        {
          value: 0,
          color: "#0086ff",
          fontColor: "white",
          label: "Lv 1",
          engLabel: "Lv 1",
        },
        {
          value: 1,
          color: "#f8ff00",
          fontColor: "black",
          label: "Lv 2",
          engLabel: "Lv 2",
        },
        {
          value: 2,
          color: "#f20022",
          fontColor: "white",
          label: "Lv 3",
          engLabel: "Lv 3",
        },
      ],
      rainLevels: [
        {
          value: 1,
          color: "#ff2800",
          fontColor: "white",
          label: "警報",
          engLabel: "Warning",
        },
        {
          value: 2,
          color: "#0c000c",
          fontColor: "white",
          label: "特別警報",
          engLabel: "Emergency Warning",
        },
      ],
      guerrillaLevels: [
        {
          value: 0,
          color: "#f2e700",
          fontColor: "black",
          label: "注意報",
          engLabel: "Advisory",
        },
        {
          value: 1,
          color: "#ff2800",
          fontColor: "white",
          label: "警報",
          engLabel: "Warning",
        },
        {
          value: 2,
          color: "#0c000c",
          fontColor: "white",
          label: "特別警報",
          engLabel: "Emergency Warning",
        },
      ],
      statusList: {
        first: null,
        second: null,
      },
    };
  },
  computed: {
    selectedRisk() {
      return this.$store.state.selectedRisk;
    },
    floodAreaStatus() {
      return this.$store.state.floodAreaStatus;
    },
  },
  watch: {
    selectedRisk: "setStatusList",
  },
  async created() {
    await this.setStatusList();
  },
  methods: {
    async loadAlertStatus() {
      try {
        const authResponse = await axios.post(
          "https://api.riskma.jp/v1/auth",
          null,
          {
            headers: { Origin: "https://www.riskma.net" },
          }
        );
        this.token = authResponse.data.access_token;

        const date = moment().format("YYYY/MM/DD HH:mm");
        const statusResponse = await axios.get(
          `https://api.riskma.jp/v1/alert/status?date=${date}`,
          {
            headers: {
              Origin: "https://www.riskma.net",
              "X-Auth-Token": this.token,
            },
          }
        );
        this.alertStatus = statusResponse.data;
      } catch (error) {
        console.error("Error fetching alert status:", error);
        this.alertStatus = [];
      }
    },
    transformAlertData() {
      if (!this.alertStatus || this.alertStatus.length === 0) {
        const legend =
          this.selectedRisk === RISK.GR
            ? this.guerrillaLevels
            : this.rainLevels;
        return { status: [], legend: legend };
      }

      const getWarningLevel = (alertName) => {
        if (alertName.includes("危険警報")) return 3;
        if (alertName.includes("特別警報")) return 2;
        if (alertName.includes("警報")) return 1;
        if (alertName.includes("注意報")) return 0;
        return -1;
      };

      const prefectureAlerts = {};

      this.alertStatus.forEach((region) => {
        region.cities.forEach((city) => {
          if (city.alerts && city.alerts.length > 0) {
            const prefCode = city.id.substring(0, 2);
            const prefName = this.prefectureMap[prefCode];
            if (prefName) {
              if (!prefectureAlerts[prefName]) {
                prefectureAlerts[prefName] = new Set();
              }
              city.alerts.forEach((alert) => {
                prefectureAlerts[prefName].add(alert);
              });
            }
          }
        });
      });

      let status = Object.keys(prefectureAlerts)
        .map((prefName) => {
          let alerts = Array.from(prefectureAlerts[prefName]);

          if (this.selectedRisk !== RISK.GR) {
            alerts = alerts.filter(
              (alertName) => !alertName.includes("注意報")
            );
          }

          if (alerts.length === 0) {
            return null;
          }

          const areas = alerts.map((alertName) => ({
            name: alertName,
            warningLevel: getWarningLevel(alertName),
          }));

          return {
            prefecture: prefName,
            engPrefecture: prefName,
            areas: areas,
            engAreas: areas,
          };
        })
        .filter((item) => item !== null);

      if (this.selectedRisk === RISK.GR) {
        status = status.filter((item) =>
          this.guerrillaRainPrefectures.includes(item.prefecture)
        );
      }

      return {
        status: status,
        legend:
          this.selectedRisk === RISK.GR
            ? this.guerrillaLevels
            : this.rainLevels,
      };
    },
    async setStatusList() {
      await this.$store.dispatch("loadWarningStatus");
      await this.loadAlertStatus();

      const alertData = this.transformAlertData();

      switch (this.selectedRisk) {
        case RISK.RR:
        case RISK.RT:
        case RISK.RE:
        case RISK.FL:
        case RISK.VWS:
        case RISK.GR:
          this.statusList = {
            first: {
              status: this.floodAreaStatus,
              legend: this.floodLevels,
            },
            second: alertData,
          };
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.warning-status {
  a {
    color: #82b1ff;
  }
}
</style>
